"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setItem = setItem;

function setItem(key, value) {
  try {
    localStorage.setItem(key, value);
  } catch (err) {// ignore
  }
}